import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear, max, startOfDay, endOfDay } from '@e3dc-react/shell/Libs/date'
import { ChartDateRangeView } from '../../models/dashboard.model'

export interface CalculateNextDateRangeParams {
  previousStartDate: Date
  previousView: ChartDateRangeView
  nextView: ChartDateRangeView
  minDate: Date
}

export interface CalculateNextDateRangeResult {
  newStartDate: Date
  newEndDate: Date
}

/**
 * Utility used to calculate what date range should be shown to the user in the E-Mobility Dashboard
 * when switching between "week", "month" and "year" views.
 *
 * Given the previous start date, previous view, next view, and the earliest session date (`minDate`),
 * this function clamps the selected date to ensure we don't go earlier than the first session and
 * then calculates the new range boundaries based on the chosen granularity.
 */
export const calculateNextDateRange = ({ previousStartDate, nextView, minDate }: CalculateNextDateRangeParams): CalculateNextDateRangeResult => {
  /** Clamp so we never go before the earliest session */
  const clampedDate = max([previousStartDate, minDate])

  if (nextView === 'week') {
    return { newStartDate: startOfWeek(clampedDate, { weekStartsOn: 1 }), newEndDate: endOfWeek(clampedDate, { weekStartsOn: 1 }) }
  }

  if (nextView === 'month') {
    return { newStartDate: startOfMonth(clampedDate), newEndDate: endOfMonth(clampedDate) }
  }

  if (nextView === 'day') {
    return { newStartDate: startOfDay(clampedDate), newEndDate: endOfDay(clampedDate) }
  }

  return { newStartDate: startOfYear(clampedDate), newEndDate: endOfYear(clampedDate) }
}
